import { changePreview, changeFullScreenMode, changeMoreImageMode } from '../related-product-builder-popup/related-product.actions';
import { selectLogo, changeLogoDimensions, adjustLogoToImprintArea } from './logo.actions';
export const makeProductEditorDispatcher = () => dispatch => ({
  onChange: rect => {
    dispatch(changeLogoDimensions(rect));
  },
  onLogoLoad: rect => {
    dispatch(changeLogoDimensions(rect));
  },
  onZoomClick: () => {
    dispatch(changeFullScreenMode());
  },
  onMoreImageModeChange: () => {
    dispatch(changeMoreImageMode());
  },
  onChangeView: index => {
    dispatch(changePreview(index));
  },
  onChangeImprintArea: (newImprintArea, oldImprintArea) => {
    dispatch(adjustLogoToImprintArea(newImprintArea, oldImprintArea));
  },
  onProductImageClick: () => {
    dispatch(selectLogo(null));
  }
});